import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { API, ReportingFileDTO, ReportingFullDTO } from '../../../services/api/api';
import { UtilService } from '../../../services/util.service';
import { ErrorService } from '../../../services/error.service';
import { ReportingService } from '../../../services/reporting.service';
import { PermissionService } from '../../../services/permission.service';
import { mergeMap, takeWhile } from 'rxjs/operators';
import { interval } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sb-page-reporting-file',
  templateUrl: './reporting-file.component.html',
  styleUrls: ['./reporting-file.component.scss'],
  standalone: false,
})
export class ReportingFileComponent implements OnInit {
  @Input() report: ReportingFullDTO;
  @Input() isInModalContext: boolean;

  destroyRef = inject(DestroyRef);

  constructor(
    public util: UtilService,
    public api: API,
    private errorHandler: ErrorService,
    private reportingService: ReportingService,
    public permissionService: PermissionService
  ) {
    this.isInModalContext = false;
  }

  ngOnInit(): void {
    if (!this.isInModalContext) {
      if (
        this.report &&
        this.report.id === this.reportingService.waitForReport &&
        !(this.report.renderingFinishedAt || this.report.renderingFailedAt || this.report.calculationFailedAt)
      ) {
        interval(5000)
          .pipe(
            takeWhile(() => this.reportingService.waitForReport !== null),
            mergeMap(() => this.api.shared_Reporting_retrieveById(this.report?.id)),
            takeUntilDestroyed(this.destroyRef)
          )
          .subscribe({
            next: (rep: ReportingFullDTO) => {
              this.report = rep;
              if (this.report?.renderingFinishedAt || this.report?.renderingFailedAt || this.report?.calculationFailedAt) {
                this.reportingService.waitForReport = null;
              }
            },
            error: error => {
              this.errorHandler.errorHandler(error);
            },
          });
      }
    }
  }

  getFile(file: ReportingFileDTO) {
    if (file) {
      this.util.downloadFileLink(file.url);
    }
  }
}
